export default defineNuxtRouteMiddleware((to, from) => {
  if (from.fullPath) {
    sessionStorage.setItem("iqa-lastRoute", from.fullPath);
  }
  // --- Control de selectedRow ---
  let selections = JSON.parse(sessionStorage.getItem("iqa-selections") || "{}");
  let modified = false;

  for (const key in selections) {
    const sel = selections[key];
    // Si cambiamos de ruta y no es la página de origen
    if (to.fullPath !== sel.origin) {
      sel.jumps++;
      modified = true;

      if (sel.jumps >= sel.maxJumps) {
        delete selections[key]; // destruir selección
      }
    }
    else if (to.fullPath === sel.origin) {
      sel.jumps = 0;
      modified = true;
    }
  }

  if (modified) {
    sessionStorage.setItem("iqa-selections", JSON.stringify(selections));
  }
});